import { generatePath, Navigate, Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { AlertsTab } from '../models';

import { alertsPaths } from './paths';

const { AlertsView } = lazyImport(() => import('../views/alerts'), 'AlertsView');
const { AlertDetailsView } = lazyImport(() => import('../views/alertDetails'), 'AlertDetailsView');
const { AlertRules } = lazyImport(() => import('../views/alertRules'), 'AlertRules');
const { CreateAlertRule } = lazyImport(() => import('../views/createUpdateAlertRule'), 'CreateAlertRule');
const { UpdateAlertRule } = lazyImport(() => import('../views/createUpdateAlertRule'), 'UpdateAlertRule');

const { AnomaliesDetailsView } = lazyImport(
  () => import('../../anomalies/views/anomaliesDetails'),
  'AnomaliesDetailsView',
);

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const alertsRoutes: RouteObject[] = [
  {
    path: alertsPaths.absolute,
    element: <Layout />,
    children: [
      { path: '', element: <Navigate to={generatePath(alertsPaths.tab.relative, { tab: AlertsTab.Alerts })} /> },
      { path: alertsPaths.alertRules.relative, element: <AlertRules /> },
      { path: alertsPaths.createAlertRules.relative, element: <CreateAlertRule /> },
      { path: alertsPaths.updateAlertRules.relative, element: <UpdateAlertRule /> },
      { path: alertsPaths.tab.relative, element: <AlertsView /> },
      { path: alertsPaths.alertDetails.relative, element: <AlertDetailsView /> },
      { path: alertsPaths.aiAnomaliesDetails.relative, element: <AnomaliesDetailsView /> },
    ],
  },
];
